export default __webpack_public_path__ + "static/media/mediaId208_0001.f3eb138f.png";